import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface StatCardProps {
  label: string;
  value: ReactNode;
  to?: string;
}

export function StatCard({ label, value, to }: StatCardProps) {
  const card = (
    <div className="card stat-card">
      <div className="label">{label}</div>
      <div className="value">{value}</div>
    </div>
  );
  if (!to) return card;
  return (
    <Link to={to} className="stat-card-link" aria-label={`View ${label}`}>
      {card}
    </Link>
  );
}
